// extracted by mini-css-extract-plugin
export default {"ServiceDetail":"serviceDetail_ServiceDetail__6chnb"};